export default function ShouldTrackErrors() {
    //this will eventually change to use OctopusJS to decide whether js error tracking is enabled
    return location.host === "deploy.octopus.app" || location.host === "main.octopus.app" || location.host.indexOf("tentaclearmy") > -1;
}
